import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { breakpoints, colors } = constants;
const { xs } = breakpoints.BreakpointNames;

export const pollContainerCss = {
  backgroundColor: colors.ui.white[700],
  border: `1px solid ${colors.ui.neutral[100]}`,
  borderRadius: "8px",
  color: colors.ui.neutral[700],
};

export const flexStyles = {
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",
};

export const pollHeaderCss = {
  borderBottom: `1px solid ${colors.ui.neutral[100]}`,
  padding: "16px 20px",
};

export const pollHeaderContentCss = {
  ...flexStyles,
};

export const pollTitleCss = {
  color: colors.ui.neutral[600],
  margin: "4px 0 0",
  ...typographyStyles.fontSize.heading4,

  [mediaQuery.upTo(xs)]: {
    ...typographyStyles.fontSize.heading5,
  },
};

export const pollEyebrowCss = {
  color: colors.status.info[500],
  fontWeight: 700,
  textTransform: "uppercase",
  ...typographyStyles.fontSize.textXS,
};

export const pollFooterCss = {
  borderTop: `1px solid ${colors.ui.neutral[100]}`,
  display: "flex",
  padding: "12px 20px",
};
